import React from 'react';
import { Button } from 'react-bootstrap';

export const DeleteButton = (props:React.HTMLAttributes<HTMLButtonElement>) =>
    <Button {...props} variant="light" style={{margin:"0", padding:"0", border:"none"}} >
        <div className="d-flex" style={{display:"flex"}}>
            <span className="petco-trash"/>
            <span style={{paddingTop:".2rem", paddingLeft:".5rem"}}>Delete</span>
        </div>
    </Button>
